'use client';

import { useAuthEffects } from '@/features/auth/hooks/use-auth-effects';

export function AuthEffects() {
  useAuthEffects();

  return null;
}
